const COLS = [
  { key: "suppliers", letter: "S", title: "Suppliers", head: "bg-blue-700" },
  { key: "inputs", letter: "I", title: "Inputs", head: "bg-blue-600" },
  { key: "process", letter: "P", title: "Process", head: "bg-amber-700" },
  { key: "outputs", letter: "O", title: "Outputs", head: "bg-blue-600" },
  { key: "customers", letter: "C", title: "Customers", head: "bg-blue-700" },
];

export default function SipocBlueprint({ doc }) {
  const p = doc.payload || {};
  return (
    <div className="overflow-x-auto" data-testid="sipoc-blueprint">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-px bg-slate-200 border border-slate-200 rounded-sm overflow-hidden min-w-[640px] md:min-w-0">
        {COLS.map((c) => {
          const items = (p[c.key] || []).filter((x) => x && x.trim());
          const ordered = c.key === "process";
          return (
            <div key={c.key} className="bg-white flex flex-col" data-testid={`sipoc-col-${c.key}`}>
              <div className={`${c.head} text-white px-3 py-2.5 flex items-center gap-2`}>
                <span className="font-mono text-sm font-bold">{c.letter}</span>
                <span className="text-xs font-semibold uppercase tracking-wide">{c.title}</span>
              </div>
              <div className="p-3 flex-1">
                {items.length === 0 ? <p className="text-xs text-slate-300">—</p> : (
                  <ol className="space-y-1.5">
                    {items.map((v, i) => (
                      <li key={i} className="flex items-start gap-2 text-sm text-slate-800">
                        <span className="mt-0.5 font-mono text-[10px] text-slate-400 w-4 shrink-0">{ordered ? `${i + 1}.` : "•"}</span>
                        <span>{v}</span>
                      </li>
                    ))}
                  </ol>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
